import { zetApi } from '@zet/network'

import {
  IOtpResponse,
  IVerifyOtpResponse,
  OtpRequest,
  SendConsentOtpRequest,
  shareReconsentOtpVerificationLinkRequest,
  VerifyConsentOtpRequest,
  VerifyOtpRequest,
} from '../types'

export async function sendConsentOtp(suppliedData: SendConsentOtpRequest) {
  const { data } = await zetApi.post(
    'customer/addCustomerOtp/v2?bureauReportConsent=true',
    {
      fullName: suppliedData?.fullName,
      phoneNumber: suppliedData?.phoneNumber,
    }
  )
  return data
}

export async function verifyConsentOtp(suppliedData: VerifyConsentOtpRequest) {
  const { data } = await zetApi.post(
    '/customer/otp/verify?bureauReportConsent=true',
    {
      otp: suppliedData?.otp,
      phoneNumber: suppliedData?.phoneNumber,
      customerId: suppliedData?.customerId,
    }
  )
  return data
}

export async function shareReconsentOtpVerificationLink(
  suppliedData: shareReconsentOtpVerificationLinkRequest
) {
  const { data } = await zetApi.get(
    `/customer/generateShareLink/v2?linkType=otpVerify&customerId=${suppliedData.customerId}&bureauReportConsent=true`
  )
  return data
}

export async function shareReconsentGlobalOtpVerificationLink(
  suppliedData: shareReconsentOtpVerificationLinkRequest
) {
  const { data } = await zetApi.get(
    `/customer/generateShareLink/v2?linkType=globalShareLink&customerId=${
      suppliedData.customerId
    }&bureauReportConsent=true${
      suppliedData?.subAgentId ? `&subAgentId=${suppliedData?.subAgentId}` : ''
    }`
  )
  return data
}

export async function getReconsentOtpWeb(suppliedData: OtpRequest) {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    hash: encodeURIComponent(suppliedData?.hash),
  }
  const { data } = await zetApi.post<IOtpResponse>(
    'customer/addCustomerOtp/v2?bureauReportConsent=true',
    {
      fullName: suppliedData?.fullName,
      phoneNumber: suppliedData?.phoneNumber,
    }
  )
  return data?.data
}

export async function verifyConsentOtpWeb(suppliedData: VerifyOtpRequest) {
  zetApi.defaults.headers.common = {
    ...zetApi.defaults.headers.common,
    hash: suppliedData?.hash,
  }
  const { data } = await zetApi.post<IVerifyOtpResponse>(
    'customer/otp/verify?bureauReportConsent=true',
    {
      customerId: suppliedData?.customerId,
      otp: suppliedData?.otp,
      phoneNumber: suppliedData?.phoneNumber,
    }
  )
  return data?.data
}
